import React from 'react';
import Account from "./Account";
import {withRouter} from "./withRouter";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            userId: null
        };
    }

     componentDidMount() {
         const {navigate} = this.props;

         fetch(process.env.REACT_APP_API_URL + '/my-account/logout', {
             method: "POST",
             headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
         }).then(res => res.json())
             .then(
                 (result) => {
                     this.setState({
                         isLoaded: true,
                     });

                     sessionStorage.removeItem('token');
                     navigate('/login');
                 },
                 (error) => {
                     this.setState({
                         isLoaded: false,
                         error,
                     });

                     navigate('/login');
                 }
             );
     }

    render() {
        return <div></div>
    }
}

export default withRouter(Logout);
